// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const TC_REQUEST_PAGE_DATA = 'TC_REQUEST_PAGE_DATA';
const TC_REQUEST_PAGE_DATA_SUCCESS = 'TC_REQUEST_PAGE_DATA_SUCCESS';

export {
  TC_REQUEST_PAGE_DATA,
  TC_REQUEST_PAGE_DATA_SUCCESS,
};
